module.exports = __webpack_public_path__ + "img/six-round.a6d05c69.svg";